<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" @close="closeModal">
      <div class="fixed inset-0 z-30 overflow-y-auto">
        <div class="min-h-screen text-center flex">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-10"
            leave="duration-200 ease-in"
            leave-from="opacity-10"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
          </TransitionChild>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-50"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-50"
          >
            <div
              class="inline-block w-full mx-3 md:w-2/3 md:mx-auto max-w-screen-md m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded overflow-y-scroll"
            >
              <div class="flex flex-row">
                <div class="flex-1"></div>
                <div class="flex-4 pr-2 pt-2 cursor-pointer" @click="closeModal(false)">
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="pb-2 px-5 md:px-8">
                <h2 class="text-xl text-brand-black py-1">Approve Applicant</h2>
                <h2 class="text-xl text-brand-black py-1">Congratulations! You found a tenant!</h2>
              </div>

              <div class="pb-2 px-5 md:px-8">
                <p class="py-1">
                  You can send your applicant an email to inform them about their tenancy.
                </p>
              </div>

              <div class="py-2 px-5 md:px-8 flex flex-row items-center">
                <input
                  id="cc"
                  type="checkbox"
                  class="rounded border-gray-300 text-brand-green focus:ring-brand-green w-4 h-4"
                  v-model="cc"
                />
                <label for="cc" class="ml-2 block text-sm text-brand-black">Send me a copy</label>
              </div>
              <div class="py-2 px-5 md:px-8 flex flex-col">
                <div class="flex flex-col">
                  <label for="subject" class="block text-brand-black"> Subject </label>
                  <SingleLineInput
                    id="subject"
                    type="text"
                    :placeholder="`Application for ${app.unit_address} Approved!`"
                    :value="subject"
                    @input="subject = $event.target.value"
                  ></SingleLineInput>
                </div>

                <div class="flex flex-col pt-5 pb-3">
                  <label for="customMessage" class="block text-brand-black"> Custom message </label>
                  <MultiLineInput
                    id="customMessage"
                    :placeholder="`Congratulations, ${app.applicant.name}! Your application to live at ${app.unit_address} has been approved.`"
                    :value="customMessage"
                    @input="customMessage = $event.target.value"
                  ></MultiLineInput>
                </div>
              </div>

              <div class="px-5 pb-8 md:px-8 flex flex-col md:flex-row justify-between w-full">
                <div class="py-1">
                  <SecondaryButton
                    :classes="'border-brand-mid-gray'"
                    @click="approveApplicant(false)"
                    >No thanks, don't send an email</SecondaryButton
                  >
                </div>
                <div class="py-1">
                  <PrimaryButton @click="approveApplicant(true)"
                    >Send the tenant an email</PrimaryButton
                  >
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { mapGetters } from "vuex"
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import { APPLICATION_BUNDLE_APPROVE } from "@/store/types"

import { XIcon } from "@heroicons/vue/outline"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    app: {
      type: Object
    }
  },
  emit: ["close"],
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    ...mapGetters(["isApplicationBundleLoading"])
  },
  data() {
    return {
      cc: false,
      subject: "",
      customMessage: ""
    }
  },
  methods: {
    closeModal(reload = false) {
      this.$emit("close", reload)
    },
    async approveApplicant(sendEmail) {
      const { subject, customMessage, cc } = this
      const slug = this.app.bundle.slug

      await this.$store.dispatch(APPLICATION_BUNDLE_APPROVE, {
        slug,
        sendEmail,
        cc,
        subject,
        customMessage
      })
      this.closeModal(true)
    }
  }
}
</script>
<style scoped></style>
